export const SliderType = 
    {
      "COMM_DTLS": "10",
      "COMM_STUDENT":"20",
    }